/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCardPayment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import PaymentProviderMethod from 'DesignSystem/PaymentProvider/PaymentProviderMethod/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CreditCardPayment({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/PaymentMethods/CreditCardPayment"
  
}) {
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let paymentsPostPaymentPaymentAccountDataPayerPersonValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payment_account.data.payer_person',
})
let paymentsPostPaymentAmountValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'amount',
})
let onPaymentPageCallback = fromHelpers.useOnPaymentPageCallback({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<PaymentProviderMethod
  viewPath={`${viewPath}/PaymentProviderMethod`}
 method="card"
 data="global.current_location._id"
 locationId={globalCurrentLocationIdValueData}
 data="payments_post_payment.payment_account.data.payer_person"
 person={paymentsPostPaymentPaymentAccountDataPayerPersonValueData}
 data="payments_post_payment.amount"
 amount={paymentsPostPaymentAmountValueData}
 onPaymentPageCallback={onPaymentPageCallback}
/>
{children}
</React.Fragment>)
}